(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["esim-tutorial-vic"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (window.__esimTutorialVicInteractionsReady) {
      return;
    }

    window.__esimTutorialVicInteractionsReady = true;

    const phoneCarouselSelector = '[data-esim-phone-carousel]';

    const initializePhoneCarousels = (scope = document) => {
      const flows = [
        ...(scope instanceof Element && scope.matches(phoneCarouselSelector) ? [scope] : []),
        ...scope.querySelectorAll(phoneCarouselSelector)
      ];

      flows.forEach((flow) => {
        if (flow.dataset.esimCarouselReady === 'true') {
          return;
        }

        const items = [...flow.children].filter((child) => {
          return child.classList.contains('esim-tutorial-vic__phone-shot') ||
            child.classList.contains('esim-tutorial-vic__phone-frame');
        });

        if (items.length < 2) {
          return;
        }

        const root = flow.closest('[data-esim-tutorial-vic]');
        const rootFlows = root ? [...root.querySelectorAll(phoneCarouselSelector)] : flows;
        const flowNumber = rootFlows.indexOf(flow) + 1;
        const flowId = flow.id || `${root?.id || 'esim-tutorial-vic'}-phone-carousel-${flowNumber}`;
        const shell = document.createElement('div');

        flow.id = flowId;
        shell.className = 'esim-tutorial-vic__carousel-shell';
        flow.before(shell);
        shell.append(flow);

        const slides = items.map((item, index) => {
          const slide = document.createElement('span');
          slide.className = 'esim-tutorial-vic__carousel-slide';
          slide.setAttribute('role', 'group');
          slide.setAttribute('aria-label', `第 ${index + 1} 張，共 ${items.length} 張`);
          item.before(slide);
          slide.append(item);
          return slide;
        });

        const createButton = (direction, label) => {
          const button = document.createElement('button');
          button.type = 'button';
          button.className = `esim-tutorial-vic__carousel-button esim-tutorial-vic__carousel-button--${direction}`;
          button.setAttribute('aria-label', label);
          button.setAttribute('aria-controls', flowId);
          shell.append(button);
          return button;
        };

        const previousButton = createButton('prev', '上一張');
        const nextButton = createButton('next', '下一張');
        let activeIndex = 0;
        let pendingStateFrame = 0;

        const slideScrollLeft = (slide) => {
          return slide.getBoundingClientRect().left - flow.getBoundingClientRect().left + flow.scrollLeft;
        };

        const updateState = () => {
          activeIndex = slides.reduce((closest, slide, index) => {
            const closestDistance = Math.abs(slideScrollLeft(slides[closest]) - flow.scrollLeft);
            const currentDistance = Math.abs(slideScrollLeft(slide) - flow.scrollLeft);
            return currentDistance < closestDistance ? index : closest;
          }, 0);

          previousButton.disabled = activeIndex === 0;
          nextButton.disabled = activeIndex === slides.length - 1;
        };

        const requestStateUpdate = () => {
          if (pendingStateFrame) {
            return;
          }

          pendingStateFrame = window.requestAnimationFrame(() => {
            pendingStateFrame = 0;
            updateState();
          });
        };

        const moveTo = (index) => {
          const targetIndex = Math.max(0, Math.min(index, slides.length - 1));
          flow.scrollTo({
            left: slideScrollLeft(slides[targetIndex]),
            behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'
          });
        };

        previousButton.addEventListener('click', () => moveTo(activeIndex - 1));
        nextButton.addEventListener('click', () => moveTo(activeIndex + 1));
        flow.addEventListener('scroll', requestStateUpdate, { passive: true });

        flow.dataset.esimCarouselReady = 'true';
        flow.setAttribute('role', 'region');
        flow.setAttribute('aria-roledescription', 'carousel');
        updateState();
      });
    };

    initializePhoneCarousels();
    document.addEventListener('shopify:section:load', (event) => initializePhoneCarousels(event.target));

    const easeOutCubic = (value) => 1 - Math.pow(1 - value, 3);

    const smoothScrollTo = (targetTop, duration) => {
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        window.scrollTo(0, targetTop);
        return;
      }

      const startTop = window.pageYOffset;
      const distance = targetTop - startTop;
      const startTime = window.performance.now();

      const step = (now) => {
        const elapsed = now - startTime;
        const progress = Math.min(elapsed / duration, 1);
        window.scrollTo(0, Math.round(startTop + distance * easeOutCubic(progress)));

        if (progress < 1) {
          window.requestAnimationFrame(step);
        }
      };

      window.requestAnimationFrame(step);
    };

    const getTargetTop = (target) => {
      const offset = parseFloat(getComputedStyle(target).scrollMarginTop) || 24;
      return Math.max(0, target.getBoundingClientRect().top + window.pageYOffset - offset);
    };

    let activeDeviceTrigger = null;
    let deviceModalCloseTimer = null;
    const deviceModalTransitionMs = 420;

    const focusableDeviceModalSelector = [
      'button:not([disabled])',
      '[href]',
      'input:not([disabled])',
      'select:not([disabled])',
      'textarea:not([disabled])',
      '[tabindex]:not([tabindex="-1"])'
    ].join(',');

    const normalizeDeviceSearch = (value) => value.normalize('NFKC').toLocaleLowerCase().replace(/\s+/g, '');

    const escapeRegExp = (value) => value.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');

    const setSearchFeedback = (root, isVisible) => {
      const feedback = root && root.querySelector('[data-esim-search-feedback]');
      if (feedback) {
        feedback.hidden = !isVisible;
      }
    };

    const closeDeviceSearchResults = (root) => {
      const input = root && root.querySelector('[data-esim-device-search]');
      const results = root && root.querySelector('[data-esim-device-results]');
      if (results) {
        results.hidden = true;
        results.replaceChildren();
      }
      if (input) {
        input.setAttribute('aria-expanded', 'false');
        input.removeAttribute('aria-activedescendant');
      }
    };

    const clearSearchHighlights = (root) => {
      if (!root) {
        return;
      }

      root.querySelectorAll('.esim-tutorial-vic__search-highlight').forEach((mark) => {
        mark.replaceWith(document.createTextNode(mark.textContent || ''));
      });
      root.normalize();
    };

    const highlightPanelQuery = (panel, query) => {
      const highlightText = query.trim();
      if (!panel || highlightText.length === 0) {
        return;
      }

      const target = panel.querySelector('.esim-tutorial-vic__device-list-card') || panel;
      const lowerQuery = highlightText.toLocaleLowerCase();
      const textNodes = [];
      const walker = document.createTreeWalker(target, NodeFilter.SHOW_TEXT, {
        acceptNode: (node) => {
          if (!node.nodeValue || !node.nodeValue.toLowerCase().includes(lowerQuery)) {
            return NodeFilter.FILTER_REJECT;
          }

          if (node.parentElement && node.parentElement.closest('.esim-tutorial-vic__search-highlight')) {
            return NodeFilter.FILTER_REJECT;
          }

          return NodeFilter.FILTER_ACCEPT;
        }
      });

      while (walker.nextNode()) {
        textNodes.push(walker.currentNode);
      }

      const matcher = new RegExp(escapeRegExp(highlightText), 'gi');
      textNodes.forEach((node) => {
        const fragment = document.createDocumentFragment();
        const text = node.nodeValue;
        let lastIndex = 0;

        text.replace(matcher, (match, offset) => {
          if (offset > lastIndex) {
            fragment.append(document.createTextNode(text.slice(lastIndex, offset)));
          }

          const mark = document.createElement('mark');
          mark.className = 'esim-tutorial-vic__search-highlight';
          mark.textContent = match;
          fragment.append(mark);
          lastIndex = offset + match.length;
          return match;
        });

        if (lastIndex < text.length) {
          fragment.append(document.createTextNode(text.slice(lastIndex)));
        }

        node.replaceWith(fragment);
      });
    };

    const getLineSeparatedText = (element) => {
      const lines = [''];
      element.childNodes.forEach((node) => {
        if (node.nodeName === 'BR') {
          lines.push('');
          return;
        }
        lines[lines.length - 1] += node.textContent || '';
      });
      return lines;
    };

    const getDeviceSearchEntries = (root) => {
      const entries = [];
      const seen = new Set();

      root.querySelectorAll('[data-esim-device-panel]').forEach((panel) => {
        const panelName = panel.getAttribute('data-esim-device-panel');
        const addEntry = (label) => {
          const highlightLabel = label.trim().replace(/\s+/g, ' ');
          const displayLabel = highlightLabel
            .replace(/\s*[（(][^（）()]*[）)]/g, '')
            .trim()
            .replace(/\s+/g, ' ');
          const searchLabel = normalizeDeviceSearch(displayLabel);
          if (!displayLabel || !searchLabel || seen.has(`${panelName}:${searchLabel}`)) {
            return;
          }
          seen.add(`${panelName}:${searchLabel}`);
          entries.push({ label: displayLabel, highlightLabel, panelName, searchLabel });
        };

        panel.querySelectorAll('li').forEach((item) => {
          const children = item.querySelectorAll(':scope > strong, :scope > span');
          if (children.length > 0) {
            children.forEach((child) => addEntry(child.textContent || ''));
          } else {
            addEntry(item.textContent || '');
          }
        });
        panel.querySelectorAll('.esim-tutorial-vic__device-lines').forEach((lines) => {
          getLineSeparatedText(lines).forEach(addEntry);
        });
      });

      return entries;
    };

    const finishDeviceModalClose = (modal) => {
      if (!modal) {
        return;
      }

      clearSearchHighlights(modal);
      closeDeviceSearchResults(modal.closest('[data-esim-tutorial-vic]'));
      modal.classList.remove('is-opening', 'is-closing');
      modal.hidden = true;
      modal.querySelectorAll('[data-esim-device-panel]').forEach((panel) => {
        panel.hidden = true;
      });

      deviceModalCloseTimer = null;

      if (activeDeviceTrigger) {
        activeDeviceTrigger.classList.add('is-device-return-focus');
        activeDeviceTrigger.focus({ preventScroll: true });
        activeDeviceTrigger = null;
      }
    };

    const closeDeviceModal = (modal) => {
      if (!modal || modal.hidden || modal.classList.contains('is-closing')) {
        return;
      }

      if (deviceModalCloseTimer) {
        window.clearTimeout(deviceModalCloseTimer);
        deviceModalCloseTimer = null;
      }

      clearSearchHighlights(modal);
      modal.classList.remove('is-opening');
      modal.classList.add('is-closing');

      const root = modal.closest('[data-esim-tutorial-vic]');
      if (root) {
        root.classList.remove('is-device-modal-open');
      }

      deviceModalCloseTimer = window.setTimeout(() => finishDeviceModalClose(modal), deviceModalTransitionMs);
    };

    const openDevicePanel = (root, panelName, returnTarget, highlightQuery = '') => {
      const modal = root && root.querySelector('[data-esim-device-modal]');
      const activePanel = modal && modal.querySelector(`[data-esim-device-panel="${panelName}"]`);
      const dialog = modal && modal.querySelector('.esim-tutorial-vic__device-modal-panel');

      if (!modal || !activePanel || !dialog) {
        return;
      }

      if (deviceModalCloseTimer) {
        window.clearTimeout(deviceModalCloseTimer);
        deviceModalCloseTimer = null;
      }

      clearSearchHighlights(modal);
      setSearchFeedback(root, false);
      closeDeviceSearchResults(root);
      activeDeviceTrigger = returnTarget || null;
      modal.classList.remove('is-closing');
      modal.classList.add('is-opening');
      root.classList.add('is-device-modal-open');
      modal.querySelectorAll('[data-esim-device-panel]').forEach((panel) => {
        panel.hidden = panel !== activePanel;
      });
      highlightPanelQuery(activePanel, highlightQuery);

      const title = activePanel.querySelector('h3');
      if (title && title.id) {
        dialog.setAttribute('aria-labelledby', title.id);
      }

      modal.hidden = false;
      window.requestAnimationFrame(() => {
        modal.classList.remove('is-opening');
      });
      dialog.focus({ preventScroll: true });
    };

    const openDeviceModal = (trigger) => {
      const root = trigger.closest('[data-esim-tutorial-vic]');
      const panelName = trigger.getAttribute('data-esim-device-trigger');
      openDevicePanel(root, panelName, trigger);
    };

    const selectDeviceSearchResult = (input, result) => {
      const root = input.closest('[data-esim-tutorial-vic]');
      input.value = result.label;
      openDevicePanel(root, result.panelName, input, result.highlightLabel || result.label);
    };

    const runDeviceSearch = (input) => {
      const root = input.closest('[data-esim-tutorial-vic]');
      const query = normalizeDeviceSearch(input.value);
      const results = root && root.querySelector('[data-esim-device-results]');

      if (!root || !results || query.length === 0) {
        setSearchFeedback(root, false);
        closeDeviceSearchResults(root);
        return;
      }

      const matches = getDeviceSearchEntries(root)
        .filter((entry) => entry.searchLabel.includes(query))
        .slice(0, 5);

      results.replaceChildren(...matches.map((result, index) => {
        const item = document.createElement('li');
        const button = document.createElement('button');
        button.type = 'button';
        button.id = `${results.id}-option-${index}`;
        button.className = 'esim-tutorial-vic__search-result';
        button.setAttribute('role', 'option');
        button.dataset.esimDeviceResult = JSON.stringify(result);
        button.textContent = result.label;
        item.append(button);
        return item;
      }));
      results.hidden = matches.length === 0;
      input.setAttribute('aria-expanded', String(matches.length > 0));
      setSearchFeedback(root, matches.length === 0);
    };

    const trapDeviceModalFocus = (event) => {
      if (event.key !== 'Tab' || !(event.target instanceof Element)) {
        return;
      }

      const modal = event.target.closest('[data-esim-device-modal]');
      if (!modal || modal.hidden) {
        return;
      }

      const focusableElements = [...modal.querySelectorAll(focusableDeviceModalSelector)].filter((element) => element.offsetParent !== null);
      if (focusableElements.length === 0) {
        return;
      }

      const firstElement = focusableElements[0];
      const lastElement = focusableElements[focusableElements.length - 1];

      if (event.shiftKey && document.activeElement === firstElement) {
        event.preventDefault();
        lastElement.focus();
      }

      if (!event.shiftKey && document.activeElement === lastElement) {
        event.preventDefault();
        firstElement.focus();
      }
    };

    document.addEventListener('input', (event) => {
      if (!(event.target instanceof Element)) {
        return;
      }

      const deviceSearchInput = event.target.closest('[data-esim-device-search]');
      if (deviceSearchInput) {
        runDeviceSearch(deviceSearchInput);
      }
    });

    document.addEventListener('click', (event) => {
      if (!(event.target instanceof Element)) {
        return;
      }

      const deviceTrigger = event.target.closest('[data-esim-device-trigger]');
      if (deviceTrigger) {
        event.preventDefault();
        openDeviceModal(deviceTrigger);
        return;
      }

      const deviceResult = event.target.closest('[data-esim-device-result]');
      if (deviceResult) {
        event.preventDefault();
        const root = deviceResult.closest('[data-esim-tutorial-vic]');
        const input = root && root.querySelector('[data-esim-device-search]');
        if (input) {
          selectDeviceSearchResult(input, JSON.parse(deviceResult.dataset.esimDeviceResult));
        }
        return;
      }

      const deviceClose = event.target.closest('[data-esim-device-close]');
      if (deviceClose) {
        event.preventDefault();
        closeDeviceModal(deviceClose.closest('[data-esim-device-modal]'));
        return;
      }

      const anchor = event.target.closest('[data-esim-scroll]');
      if (anchor) {
        const target = document.querySelector(anchor.getAttribute('href'));
        if (target) {
          event.preventDefault();
          smoothScrollTo(getTargetTop(target), Number(anchor.dataset.scrollDuration) || 1022);
        }
      }

      const topButton = event.target.closest('[data-esim-scroll-top]');
      if (topButton) {
        event.preventDefault();
        smoothScrollTo(0, Number(topButton.dataset.scrollDuration) || 754);
      }
    });

    document.addEventListener('pointerdown', (event) => {
      if (event.target instanceof Element) {
        event.target.closest('.is-device-return-focus')?.classList.remove('is-device-return-focus');
      }
    });

    document.addEventListener('keydown', (event) => {
      document.querySelectorAll('.is-device-return-focus').forEach((element) => {
        element.classList.remove('is-device-return-focus');
      });
      if (event.target instanceof Element && event.target.matches('[data-esim-device-search]') && event.key === 'Enter') {
        event.preventDefault();
        const root = event.target.closest('[data-esim-tutorial-vic]');
        const firstResult = root && root.querySelector('[data-esim-device-result]');
        if (firstResult) {
          selectDeviceSearchResult(event.target, JSON.parse(firstResult.dataset.esimDeviceResult));
        }
        return;
      }

      trapDeviceModalFocus(event);

      if (event.key !== 'Escape') {
        return;
      }

      document.querySelectorAll('[data-esim-device-modal]').forEach((modal) => {
        closeDeviceModal(modal);
      });
    });

    const toggleButtons = () => {
      document.querySelectorAll('[data-esim-scroll-top]').forEach((button) => {
        button.classList.toggle('is-visible', window.pageYOffset > 480);
      });
    };

    toggleButtons();
    window.addEventListener('scroll', toggleButtons, { passive: true });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
